module.exports = __webpack_public_path__ + "static/img/player_03_ph.e4947da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_03_ph.png
// module id = i4sI
// module chunks = 0